import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Container,
    Image,
    HeaderTitle,
    SubHeaderTitle,
    ContainerHeader,
    ContainerCol,
    ContainerList,
    SubContainerButton,
    ContainerImage,
    ContainerContent,
} from './style';
import Button from '../../components/Button/Button';
import logo from '../../assets/images/logo.png';
import CurrentTime from '../../components/CurrentTime/CurrentTime';
import {
    fetchAtualizarSenhaStart,
    atualizarSenhaReset,
} from '../../services/store/reducers/endpoints/atualizarSenha';
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo';
import Calendar from 'react-calendar';
import { fetchProtocolsStart } from '../../services/store/reducers/endpoints/protocols';
import {
    fetchProtocolsByMonthStart,
    protocolsByMonthReset,
} from '../../services/store/reducers/endpoints/getProtocolsByMonth';

class CalendarPage extends PureComponent {
    state = {
        date: new Date(),
        lastDayMoth: new Date(),
        oneYearOld: new Date(),
        loading: true,
        currentMonth: null,
        currentYear: null,
        populated: false,
    };

    componentDidMount() {
        let currentMonth = new Date().getMonth() + 1;
        let currentYear = new Date().getFullYear();

        this.setState({ currentMonth: currentMonth, currentYear: new Date().getFullYear() }, () => {
            this.props.fetchProtocolsByMonthStart({
                re: this.props.registerPoint.re,
                codempresa: this.props.home.company,
                month: currentMonth,
                year: currentYear,
            });

            let today = new Date();
            let lastDayMoth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            this.setState({ lastDayMoth: lastDayMoth });

            let oneYearOld = new Date();
            oneYearOld.setFullYear(oneYearOld.getFullYear() - 1);
            this.setState({ oneYearOld: oneYearOld });

            // console.log('oneYearOld', oneYearOld);
            // console.log('lastDayMoth', lastDayMoth);
        });
    }

    populateDates = () => {
        const { getProtocolsByMonth } = this.props;
        // console.log('logs aaaaaaaaaaaaaqui');
        this.setState({ loading: false });
        let dates = [];
        for (let i in getProtocolsByMonth) {
            // console.log('logs if for', dates);
            let partes = getProtocolsByMonth[i].data.split('/');
            let ano = partes[2];
            let mes = partes[0];
            let dia = partes[1];
            // console.log(
            //     '42 populateDates',
            //     mes,
            //     '-',
            //     this.state.currentMonth,
            //     '-',
            //     ano,
            //     '-',
            //     this.state.currentYear
            // );
            // if (mes === this.state.currentMonth && ano === this.state.currentYear) {
            dates.push(parseInt(dia));
            // console.log('logs if dates', dates);
            // }
        }

        // console.log('=============>>', dates);
        //fazer as coisas aqui
        this.removeAllActivities();
        // console.log('logs dates', dates);
        this.selectNecessaries(dates);
    };

    removeAllActivities = () => {
        let marcar = document.querySelector('.react-calendar').getElementsByTagName('abbr');
        for (let i in marcar) {
            try {
                document
                    .querySelector('.react-calendar')
                    .getElementsByTagName('abbr')
                    [i].parentElement.classList.remove('react-calendar__tile--active');
            } catch (e) {}
        }
    };

    selectNecessaries = (dateSelecteds) => {
        // console.log('logs dateSelecteds', dateSelecteds);
        let marcar = document.querySelector('.react-calendar').getElementsByTagName('abbr');
        let thisMonth = false;
        let diasJaMarcados = [];
        for (let i in marcar) {
            //console.log('thisMonth', marcar[i].innerHTML , thisMonth)
            if (thisMonth) {
                try {
                    let text = marcar[i].innerHTML;
                    // console.log('aquii::' + text);
                    if (!isNaN(text)) {
                        // console.log(
                        //     'text=',
                        //     ':' + text + ':',
                        //     ':' + dateSelecteds[0] + ':',
                        //     dateSelecteds.includes(parseInt(text)),
                        //     diasJaMarcados,
                        //     text,
                        //     diasJaMarcados.includes(text)
                        // );
                        // console.log(
                        //     'parametros: ',
                        //     dateSelecteds,
                        //     text,
                        //     diasJaMarcados,
                        //     'Validação: ',
                        //     dateSelecteds.includes(text),
                        //     !diasJaMarcados.includes(text)
                        // );
                        if (
                            dateSelecteds.includes(parseInt(text)) &&
                            !diasJaMarcados.includes(text)
                        ) {
                            diasJaMarcados.push(text);
                            document
                                .querySelector('.react-calendar')
                                .getElementsByTagName('abbr')
                                [i].parentElement.classList.add('react-calendar__tile--active');

                            document
                                .querySelector('.react-calendar')
                                .getElementsByTagName('abbr')
                                [i].parentElement.setAttribute(
                                    'style',
                                    'background-color:#F26522;'
                                );
                        }
                    }
                } catch (e) {
                    console.log('nao pegou');
                }
            } else {
                try {
                    let text = marcar[i].innerHTML;
                    // console.log('text===', text);
                    if (parseInt(text) === 1) {
                        // console.log('entrou text===', text);
                        thisMonth = true;
                        if (dateSelecteds.includes(parseInt(text))) {
                            diasJaMarcados.push(text);
                            document
                                .querySelector('.react-calendar')
                                .getElementsByTagName('abbr')
                                [i].parentElement.classList.add('react-calendar__tile--active');

                            document
                                .querySelector('.react-calendar')
                                .getElementsByTagName('abbr')
                                [i].parentElement.setAttribute(
                                    'style',
                                    'background-color:#F26522;'
                                );
                        }
                    }
                } catch (e) {}
            }
        }
    };

    voltar() {
        // window.history.back()
        window.location.href = '/confirmation-point';
    }

    paraRegisterPoint() {
        window.location.href = '/register-point';
    }

    onChangeDate = (date) => {
        this.props.protocolsByMonthReset();
        // console.log('42 aaaaaaaaaaaaaaaaaaquio');
        this.setState({ loading: true });
        let currentMonth = new Date(date).getMonth() + 1;
        let currentYear = new Date(date).getFullYear();
        this.setState({ currentMonth: currentMonth, currentYear: currentYear });
        this.props.fetchProtocolsByMonthStart({
            re: this.props.registerPoint.re,
            codempresa: this.props.home.company,
            month: currentMonth,
            year: currentYear,
        });
        // console.log('currents=' + currentMonth + '/' + currentYear)
        // this.setState({ currentMonth: currentMonth, currentYear: currentYear }, () => {
        //   this.populateDates()

        //   console.log('-----------------', date)

        //   /*console.log('****', this.state.dates.includes(parseInt(new Date(date).getDate())))
        //   if(this.state.dates.includes(parseInt(new Date(date).getDate()))){
        //     this.clicouEmUmDiaValido(date)
        //   }*/

        // })
    };

    onChangeMonth = (value) => {
        // console.log(value);
        if (value.hasOwnProperty('activeStartDate')) {
            this.onChangeDate(value.activeStartDate);
        } else {
            this.onChangeDate(value);
        }
    };

    onClickDay = (value) => {
        // debugger;
        let date = new Date(value);
        let day = date.getDate();

        const { getProtocolsByMonth } = this.props;

        let dates = [];
        for (let i in getProtocolsByMonth) {
            let partes = getProtocolsByMonth[i].data.split('/');
            let ano = partes[2];
            let mes = partes[0];
            let dia = partes[1];

            if (mes == this.state.currentMonth && ano == this.state.currentYear) {
                dates.push(parseInt(dia));
            }
        }

        // console.log('============', dates, day, dates.includes(parseInt(day)));

        if (dates.includes(parseInt(day))) {
            // console.log('clicou em um dia válido', date);
            let dateSelect = new Date(date);
            let dateToApi =
                dateSelect.getFullYear() +
                '-' +
                (dateSelect.getMonth() + 1) +
                '-' +
                dateSelect.getDate();
            let dateToShow =
                dateSelect.getDate() +
                '/' +
                (dateSelect.getMonth() + 1) +
                '/' +
                dateSelect.getFullYear();

            window.location.href =
                '/protocol-list?dateToApi=' + dateToApi + '&dateToShow=' + dateToShow;
        }
    };

    render() {
        const { sagaProtocols, getProtocolsByMonth } = this.props;
        const { loading } = this.state;
        // console.log(sagaProtocols);
        // console.log('42 getProtocolsByMonth', getProtocolsByMonth);

        // if(loading){
        //   this.populateDates()
        // }
        return (
            <Container>
                <ContainerImage>
                    <Image src={logo} />
                </ContainerImage>
                <CurrentTime></CurrentTime>
                <ContainerHeader>
                    <HeaderTitle>Ponto</HeaderTitle>
                    <SubHeaderTitle>Consulte no calendário os seus protocolos</SubHeaderTitle>
                </ContainerHeader>

                <ContainerContent>
                    <ContainerCol>
                        <ContainerList>
                            <Calendar
                                onClickDay={this.onClickDay}
                                onChange={this.onChangeDate}
                                value={this.state.date}
                                maxDate={this.state.lastDayMoth}
                                minDate={this.state.oneYearOld}
                                onClickMonth={this.onChangeMonth}
                                onActiveDateChange={this.onChangeMonth}
                            />
                        </ContainerList>
                    </ContainerCol>
                </ContainerContent>

                <SubContainerButton>
                    <Button
                        width='130px'
                        backgroundColor='#40bbca'
                        onClick={() => {
                            this.voltar();
                        }}
                    >
                        Voltar
                    </Button>
                </SubContainerButton>
                {loading && getProtocolsByMonth && this.populateDates()}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    registerPoint: state.registerPoint,
    token: state.token.token,
    configuration: state.configuration,
    home: state.home,
    sagaAtualizarSenha: state.sagaAtualizarSenha.data,
    sagaProtocols: state.sagaProtocols.data,
    getProtocolsByMonth: state.getProtocolsByMonth.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value)),
    fetchAtualizarSenhaStart: (mss) => dispatch(fetchAtualizarSenhaStart(mss)),
    atualizarSenhaReset: () => dispatch(atualizarSenhaReset()),
    fetchProtocolsStart: (mss) => dispatch(fetchProtocolsStart(mss)),
    fetchProtocolsByMonthStart: (mss) => dispatch(fetchProtocolsByMonthStart(mss)),
    protocolsByMonthReset: () => dispatch(protocolsByMonthReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarPage);
